import { render, staticRenderFns } from "./PackagingCodeList.vue?vue&type=template&id=e719b0cc&scoped=true&"
import script from "./PackagingCodeList.vue?vue&type=script&lang=js&"
export * from "./PackagingCodeList.vue?vue&type=script&lang=js&"
import style0 from "./PackagingCodeList.vue?vue&type=style&index=0&id=e719b0cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e719b0cc",
  null
  
)

export default component.exports